<div class="create-question-dropdown-container">
  <app-dropdown
    class="icon margin-top-1 create-question-dropdown"
    id="create-question-dropdown"
    #ngModelDropdown
    [options]="questionTypesList"
    name="ngModelDropdown"
    [placeholder]="createTestText"
    (selectionChange)="createNewQuestion($event)"
    [selected]="selectedOption"
    syncWidths="false"
    [updateDropdownLabel] = "false"
    [showSelectedIcon] = "false"
    [dropdownMenuCustomClass] = "createQuestionMenuList"
    [previousFocusedElement]="currentFocusedElement"
    [automationIdPrefix]="'create-question-dropdown'"
  ></app-dropdown>
</div>